import { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';

export default function Generations({userEmailAddress}) {
    const [generations, setGenerations] = useState([])
    const [openIndex, setOpenIndex] = useState(null);
    const { authToken } = useAuth();

    useEffect(() => {
        const fetchGenerations = async () => {
            const response = await fetch(`/generations/${userEmailAddress}`, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });
            const data = await response.json();
            setGenerations(data);
        }
    
        fetchGenerations();
    }, [userEmailAddress]);

    return (
        <div className="flex flex-wrap p-2 text-center m-2 sm:m-10">
    {generations.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)).map((generation, i) => {
        const date = new Date(generation.timestamp);
        const formattedDate = `${date.getMonth() + 1}/${date.getDate()}`;
        const subjectPreview = generation.copy.subject ? generation.copy.subject.substring(0, 26) : '';
        const subjectPreviewWithEllipsis = generation.copy.subject && generation.copy.subject.length > 26 ? `${subjectPreview}...` : subjectPreview;
    
        const bodyPreview = generation.copy.body ? generation.copy.body.substring(0, 37) : '';
        const bodyPreviewWithEllipsis = generation.copy.body && generation.copy.body.length > 30 ? `${bodyPreview}...` : bodyPreview;
    
        // Split the body into lines and find the first line after the salutation
        const lines = generation.copy.body ? generation.copy.body.split('\n') : [];
const salutationIndex = lines.findIndex(line => line.includes(','));
const firstLineAfterSalutation = salutationIndex !== -1 && salutationIndex + 1 < lines.length ? lines[salutationIndex + 1] : '';
        return (
            <div key={i} className="w-full lg:w-1/3 sm:w-10/12 flex flex-col items-center p-4">
    <div tabIndex={0} className="collapse collapse-arrow w-full bg-white shadow-2xl max-w-4xl p-5 sm:p-5 rounded-none" onClick={() => setOpenIndex(openIndex === i && openIndex !== null ? null : i)}>
        <div className="collapse-title text-xl font-medium">
            {openIndex === i && openIndex !== null ? formattedDate : `${formattedDate} - ${subjectPreviewWithEllipsis} ${firstLineAfterSalutation}`}
            {openIndex !== i && <p className="text-sm text-gray-500">{bodyPreviewWithEllipsis}</p>}
        </div>
        <div className="collapse-content">
            <h2 className="font-semibold text-3xl text-gray-900 mb-6">{generation.copy.subject}</h2>
            <p className="text-left text-lg whitespace-pre-wrap">{generation.copy.body}</p>
        </div>
    </div>
</div>
        );
    })}
        </div>
    )
}